import { render, staticRenderFns } from "./acceptBasicOffer.vue?vue&type=template&id=d7bb4c5c&"
import script from "./acceptBasicOffer.vue?vue&type=script&lang=js&"
export * from "./acceptBasicOffer.vue?vue&type=script&lang=js&"
import style0 from "./acceptBasicOffer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VSimpleTable})
